export const EDIT = require("./edit.webp");
export const LEAF = require("./leaf.webp");
export const TAKE_PHOTO = require("./take-photo.webp");
export const BLUR_IMAGE_DETECT_PROMPT = require("./blur-image-detect-prompt.webp");
export const FOCUS_IMAGE_DETECT_PROMPT = require("./focus-image-detect-prompt.webp");
export const GET_DIAGNOSIS = require("./get-diagnosis.webp");
export const SELECT_CROP_TYPE = require("./select-crop-type.webp");
export const BLUR_IMG_MODAL = require("./blur-image-modal.webp");
export const DIAGNOSIS_UNDER_PROCESS = require("./diagnosis-under-process.gif");
export const BACK_ARROW_BUTTON = require("./back-arrow.webp");
export const POWERED_BY_PLANTIX = require("./powered-by-plantix.webp");
export const SOMETHING_WENT_WRONG = require("./somehing-went-wrong.webp");
export const CROP_NOT_SUPPORTED = require("./crop-not-supported.webp");
export const HEALTHY_CROP = require("./healthy-crop.webp");
export const RIGHT_ARROW = require("./right-arrow.webp");
export const BACK = require("./back.webp");
export const ORNAMENTAL_PLANT = require("./ornamental.webp");
export const NOT_A_PLANT = require("./not-a-plant.webp");
export const TOO_FAR = require("./too-far.webp");
export const TOO_FAR_WRONG = require("./too-far-wrong.webp");
export const TOO_FAR_CORRECT = require("./too-far-correct.webp");
export const UNSUPORTED_MEDIA_FILE = require("./unsupported-media.webp");
export const MOVE_CLOSER = require("./move-closer.webp");
export const CAMERA_FOCUSED = require("./camera-focused.webp");
export const CLEARLY_VISIBLE = require("./clearly-visible.webp");
export const TICK = require("./tick.webp");
export const LANGUAGE = require("./language.webp");
